"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnexpectedApiError = exports.ForbiddenError = exports.UnauthorizedError = exports.NetworkError = exports.RateLimitError = exports.ValidationError = exports.ClientViewUnavailableError = exports.ClientViewNotFoundError = exports.ClientViewSdkError = void 0;
exports.normalizeApiError = normalizeApiError;
class ClientViewSdkError extends Error {
    constructor(message, { status = 0, code = "ClientViewSdkError", body, } = {}) {
        super(message);
        this.name = "ClientViewSdkError";
        this.status = status;
        this.code = code;
        this.body = body;
    }
}
exports.ClientViewSdkError = ClientViewSdkError;
class ClientViewNotFoundError extends ClientViewSdkError {
    constructor(message = "Client view not found.", body = null) {
        super(message, { status: 404, code: "ClientViewNotFoundError", body });
        this.name = "ClientViewNotFoundError";
    }
}
exports.ClientViewNotFoundError = ClientViewNotFoundError;
class ClientViewUnavailableError extends ClientViewSdkError {
    constructor(message = "Client view is not available.", body = null) {
        super(message, { status: 404, code: "ClientViewUnavailableError", body });
        this.name = "ClientViewUnavailableError";
    }
}
exports.ClientViewUnavailableError = ClientViewUnavailableError;
class ValidationError extends ClientViewSdkError {
    constructor(message = "Validation failed.", fieldErrors = [], body = null) {
        super(message, { status: 400, code: "ValidationError", body });
        this.name = "ValidationError";
        this.fieldErrors = fieldErrors;
    }
}
exports.ValidationError = ValidationError;
class RateLimitError extends ClientViewSdkError {
    constructor(message = "Too many requests.", retryAfterSeconds = null, body = null) {
        super(message, { status: 429, code: "RateLimitError", body });
        this.name = "RateLimitError";
        this.retryAfterSeconds = retryAfterSeconds;
    }
}
exports.RateLimitError = RateLimitError;
class NetworkError extends ClientViewSdkError {
    constructor(message = "Network request failed.") {
        super(message, { status: 0, code: "NetworkError" });
        this.name = "NetworkError";
    }
}
exports.NetworkError = NetworkError;
class UnauthorizedError extends ClientViewSdkError {
    constructor(message = "Unauthorized.", body = null) {
        super(message, { status: 401, code: "UnauthorizedError", body });
        this.name = "UnauthorizedError";
    }
}
exports.UnauthorizedError = UnauthorizedError;
class ForbiddenError extends ClientViewSdkError {
    constructor(message = "Forbidden.", body = null) {
        super(message, { status: 403, code: "ForbiddenError", body });
        this.name = "ForbiddenError";
    }
}
exports.ForbiddenError = ForbiddenError;
class UnexpectedApiError extends ClientViewSdkError {
    constructor(message = "Unexpected server error.", body = null) {
        super(message, { status: 500, code: "UnexpectedApiError", body });
        this.name = "UnexpectedApiError";
    }
}
exports.UnexpectedApiError = UnexpectedApiError;
function normalizeApiError(status, body, fallbackMessage) {
    const message = (typeof body?.message === "string" && body.message) || fallbackMessage;
    if (status === 400) {
        const errors = Array.isArray(body?.errors)
            ? body.errors.map((entry) => {
                if (entry && typeof entry === "object") {
                    const record = entry;
                    return {
                        path: String(record.path || record.field || ""),
                        message: String(record.message || "Invalid value."),
                    };
                }
                return { path: "", message: String(entry) };
            })
            : [];
        return new ValidationError(message, errors, body);
    }
    if (status === 401) {
        return new UnauthorizedError(message, body);
    }
    if (status === 403) {
        return new ForbiddenError(message, body);
    }
    if (status === 404) {
        if (/not found|unavailable|no published/i.test(message)) {
            return new ClientViewUnavailableError(message, body);
        }
        return new ClientViewNotFoundError(message, body);
    }
    if (status === 429) {
        return new RateLimitError(message, null, body);
    }
    if (status >= 500) {
        return new UnexpectedApiError(message, body);
    }
    return new ClientViewSdkError(message, { status, code: "ClientViewSdkError", body });
}
